export default __webpack_public_path__ + "static/media/Venturer's Leggings of the Second Caste.f2bad995.jpg";